export const ANY_PAGE_THAT_WILL_BE_REPLACED_IN_CONTENT = 'anypagethatwillbereplacedincontent';
